export default __webpack_public_path__ + "static/media/loading.e891f928.gif";